import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultSize } from "../../data/sizeData";
import { doRequest } from "../../utils/helper";

const initialState = {
  dimensions: {},
  selectedType: null,
  sizes: [...defaultSize],
  isLoading: false,
  isSizeFetched: false,
  error: null,
};

const generateSizeDimensions = (sizes, type) => {
  const calculateDimensions = (inchWidth, inchHeight) => ({
    width: Math.round(parseFloat(inchWidth) * 72),
    height: Math.round(parseFloat(inchHeight) * 72),
    downloadWidth: Math.round(parseFloat(inchWidth) * 300),
    downloadHeight: Math.round(parseFloat(inchHeight) * 300),
    inchWidth,
    inchHeight,
    inch: `${inchWidth} X ${inchHeight} in`,
  });

  const dimensions = {};

  sizes.forEach((size) => {
    let age = size.age;
    // Convert AGE/Age to Yr
    age = age.replace(/AGE|Age/g, "Yr");
    age = age.replace(/ /g, "_");
    age = age.replace(/_TO_/g, "-");

    if (type === "back") {
      dimensions[age] = {
        ...calculateDimensions(size.width, size.height),
        size: age,
        sizeNumber: size.label,
        sizeLabel: size.age,
        // size: size.label
      };
    } else if (type === "halfSleeves") {
      dimensions[age] = {
        ...calculateDimensions(size.halfSleeveWidth, size.halfSleeveHeight),
        size: age,
        sizeNumber: size.label,
        sizeLabel: size.age,
        // size: size.label
      };
    } else if (type === "fullSleeves") {
      dimensions[age] = {
        ...calculateDimensions(size.fullSleeveWidth, size.fullSleeveHeight),
        size: age,
        sizeNumber: size.label,
        sizeLabel: size.age,
        // size: size.label
      };
    } else {
      dimensions[age] = {
        ...calculateDimensions(size.fullSleeveWidth, size.fullSleeveHeight),
        size: age,
        sizeNumber: size.label,
        sizeLabel: size.age,
        // size: size.label
      };
    }
  });

  return dimensions;
};

// export const fetchSizes = createAsyncThunk(
//   'size/fetchSizes',
//   async (userId, { rejectWithValue }) => {
//     try {
//       const data = await doRequest(null, 'GET', `size/list?user_id=${userId}&type=India`);
//       if (data?.resultFlag === 1 && data?.response?.preset) {
//         return defaultSize.map(size => {
//           const matchingPreset = data.response.preset.find(preset => preset.size_name === size.age);
//           if (matchingPreset) {
//             console.log('matchingPreset', matchingPreset);
//             return {
//               ...size,
//               id: matchingPreset.id,
//               width: matchingPreset.tshirt_width !== undefined && matchingPreset.tshirt_width !== '' ? matchingPreset.tshirt_width : size.width,
//               height: matchingPreset.tshirt_height !== undefined && matchingPreset.tshirt_height !== '' ? matchingPreset.tshirt_height : size.height,
//               halfSleeveWidth: matchingPreset.half_sleeve_width !== undefined && matchingPreset.half_sleeve_width !== '' ? matchingPreset.half_sleeve_width : size.halfSleeveWidth,
//               halfSleeveHeight: matchingPreset.half_sleeve_height !== undefined && matchingPreset.half_sleeve_height !== '' ? matchingPreset.half_sleeve_height : size.halfSleeveHeight,
//               fullSleeveWidth: matchingPreset.full_sleeve_width !== undefined && matchingPreset.full_sleeve_width !== '' ? matchingPreset.full_sleeve_width : size.fullSleeveWidth,
//               fullSleeveHeight: matchingPreset.full_sleeve_height !== undefined && matchingPreset.full_sleeve_height !== '' ? matchingPreset.full_sleeve_height : size.fullSleeveHeight
//             };
//           }
//           console.log('no matchingPreset found for size:', size);
//           return size;
//         });
//       } else {
//         return rejectWithValue(data?.message || 'Failed to fetch sizes');
//       }
//     } catch (error) {
//       return rejectWithValue('Failed to load sizes. Please try again.');
//     }
//   }
// );

const getProfileList = async () => {
  let data = {};
  try {
    const response = await doRequest(data, "GET", "sizesheet/profiles");
    // console.log("response", response);
    let arr = response.filter((i) => i.is_default === true);
    let fil = response.filter((i) => i.is_active === true);
    let id = fil.length > 0 ? fil[0]?.id : arr[0]?.id;
    let res = await doRequest("", "GET", `sizesheet/sizes?profileId=${id}`);
    return res;
  } catch (error) {
    console.log("error", error);
  }
};

export const fetchSizes = createAsyncThunk(
  "size/fetchSizes",
  async (userId, { rejectWithValue }) => {
    try {
      const data = await getProfileList();
      // console.log("data", data);
      if (data?.categories && Array.isArray(data.categories)) {
        // Extract categories
        const tshirtCategory = data.categories.find(
          (c) => c.category_name === "Teeshirt Sizes"
        );
        const halfSleeveCategory = data.categories.find(
          (c) => c.category_name === "Half Sleeve Sizes"
        );
        const fullSleeveCategory = data.categories.find(
          (c) => c.category_name === "Full Sleeve Sizes"
        );

        return defaultSize.map((size) => {
          const tshirtSize = tshirtCategory?.sizes?.[size.age];
          const halfSleeveSize = halfSleeveCategory?.sizes?.[size.age];
          const fullSleeveSize = fullSleeveCategory?.sizes?.[size.age];

          if (tshirtSize || halfSleeveSize || fullSleeveSize) {
            return {
              ...size,
              id: tshirtSize?.id || size.id,
              width:
                tshirtSize?.width !== undefined && tshirtSize?.width !== ""
                  ? parseFloat(tshirtSize.width)
                  : size.width,
              height:
                tshirtSize?.height !== undefined && tshirtSize?.height !== ""
                  ? parseFloat(tshirtSize.height)
                  : size.height,
              halfSleeveWidth:
                halfSleeveSize?.width !== undefined &&
                halfSleeveSize?.width !== ""
                  ? parseFloat(halfSleeveSize.width)
                  : size.halfSleeveWidth,
              halfSleeveHeight:
                halfSleeveSize?.height !== undefined &&
                halfSleeveSize?.height !== ""
                  ? parseFloat(halfSleeveSize.height)
                  : size.halfSleeveHeight,
              fullSleeveWidth:
                fullSleeveSize?.width !== undefined &&
                fullSleeveSize?.width !== ""
                  ? parseFloat(fullSleeveSize.width)
                  : size.fullSleeveWidth,
              fullSleeveHeight:
                fullSleeveSize?.height !== undefined &&
                fullSleeveSize?.height !== ""
                  ? parseFloat(fullSleeveSize.height)
                  : size.fullSleeveHeight,
            };
          }

          // No matching sizes found
          return size;
        });
      } else {
        return rejectWithValue(data?.message || "Failed to fetch sizes");
      }
    } catch (error) {
      return rejectWithValue("Failed to load sizes. Please try again.");
    }
  }
);

export const sizeDimensionSlice = createSlice({
  name: "sizeDimension",
  initialState,
  reducers: {
    setDimensions: (state, action) => {
      const { selectedType } = action.payload;
      if (state.sizes && state.sizes.length > 0) {
        const dimensions = generateSizeDimensions(state.sizes, selectedType);
        state.dimensions = dimensions;
        state.selectedType = selectedType;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSizes.pending, (state) => {
        state.dimensions = {}; 
        state.sizes = []; 
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSizes.fulfilled, (state, action) => {
        state.sizes = action.payload;
        state.isLoading = false;
        state.isSizeFetched = true;
      })
      .addCase(fetchSizes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { setDimensions } = sizeDimensionSlice.actions;
export default sizeDimensionSlice.reducer;
